export default function TempsOutline(){
  return(
    <div>
      Template Outline coming soon!
    </div>
  );
}